import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import PlayingCard from "../../cmp/PlayingCard";
import { useRecoilValue } from "recoil";
import { Game, Pile, nertzPlayerMessage } from "../../api/NertzApi";
import { CardHeight } from "../../api/CardApi";
import { TagFacesTwoTone } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { Me } from "../../api/MeApi";

function NertzPile() {
  const params = useParams(),
    pile = useRecoilValue(Pile),
    game = useRecoilValue(Game),
    me = useRecoilValue(Me),
    cardHeight = useRecoilValue(CardHeight),
    [busy, setBusy] = useState(false),
    getColor = () => {
      let myPile = 13,
        lowPile = 13;

      if (!game || !game.players) {
        return "success.main";
      }

      game.players.forEach((p) => {
        if (p.id === me.userId) {
          myPile = p.nertz;
        } else if (p.nertz < lowPile) {
          lowPile = p.nertz;
        }
      });

      if (myPile === lowPile) {
        return "warning.main";
      } else if (myPile < lowPile) {
        return "success.main";
      } else if (myPile > lowPile) {
        return "error.main";
      }
    };

  return (
    <Card id="nertz-pile" raised>
      <CardHeader
        title={
          <Stack direction="row">
            <Typography variant="inherit">{"Nertz Pile ("}</Typography>
            <Typography sx={{ color: getColor() }} variant="inherit">
              {pile.length}
            </Typography>
            <Typography variant="inherit">{")"}</Typography>
          </Stack>
        }
      />
      <CardContent sx={{ textAlign: "center" }}>
        <Stack direction="row" sx={{ height: cardHeight }}>
          <Box sx={{ flexGrow: 1 }} />
          {pile.length ? (
            <PlayingCard cardType="nertz" {...pile[0]} />
          ) : (
            <Stack>
              <Box sx={{ flexGrow: 1 }} />
              <Button
                disabled={busy}
                onClick={() => {
                  setBusy(true);
                  nertzPlayerMessage(params.id, {
                    nertz: true,
                  }).then(() => setBusy(false));
                }}
                startIcon={<TagFacesTwoTone />}
                variant="contained"
              >
                Nertz!
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Stack>
          )}
          <Box sx={{ flexGrow: 1 }} />
        </Stack>
      </CardContent>
    </Card>
  );
}

export default NertzPile;
